import { getEndDate } from './getEndDate';
import { isActive } from './isActive';
import type { CampaignType } from './types';

export function isExpired(campaign: CampaignType) {
  return !isActive(campaign) && new Date() > getEndDate(campaign);
}
